import React, { useContext, useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import httpRequest from "../../httpRequest";
import userContext from "../../context/user-context";
import AppLayout from "../../components/AppLayout/AppLayout";
import Tabbar from "../../components/Tabbar/Tabbar";
import { useStyles } from "./styles";

const BulkScan = () => {
  const classes = useStyles();
  const userCtx = useContext(userContext);
  const [userName, setUserName] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [invoices, setInvoices] = useState([]);
  const [bulkVendorCode, setBulkVendorCode] = useState("");
  const [files, setFiles] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const resp = await httpRequest.get(`${process.env.REACT_APP_BACKEND_URL}/@me`);
        userCtx.setUserName(resp.data.name);
        userCtx.setEmail(resp.data.email);
        userCtx.setRole(resp.data.role_id);
        setUserName(resp.data.name);
      } catch (error) {
        enqueueSnackbar("Not authenticated", { variant: "error" });
        window.location.href = "/login";
      }
    })();
  }, [userCtx, enqueueSnackbar]);

  // Check permission to add invoice on component mount
  useEffect(() => {
    const checkCanAddInvoice = async () => {
      try {
        const resp = await httpRequest.get(`${process.env.REACT_APP_BACKEND_URL}/get-roles`);
        const roles = resp.data.roles;
        const userRole = roles.find(r => r.id === userCtx.role);

        if (userRole && !userRole.can_add_invoice) {
          window.location.href = "/"; // Redirect if user does not have permission to add invoice
        }
      } catch (error) {
        console.error("Error checking add invoice permission:", error);
      }
    };

    checkCanAddInvoice();
  }, [userCtx.role]);

  const handleFileChange = (event) => {
    setFiles(event.target.files);
  };

  const handleBulkScan = async (event) => {
    event.preventDefault();
    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
    }

    try {
      const resp = await httpRequest.post(`${process.env.REACT_APP_BACKEND_URL}/bulk-engine`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (resp.status === 200) {
        const { invoices } = resp.data;
        setInvoices(invoices.map(inv => ({
          ...inv,
          vendorCode: '',
          selected: false
        })));
        enqueueSnackbar("Bulk scan successful", { variant: "success" });
      } else {
        enqueueSnackbar("Error: " + resp.data.error, { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("Error: " + error.message, { variant: "error" });
    }
  };

  const handleVendorCodeChange = (event) => {
    setBulkVendorCode(event.target.value);
    setInvoices(invoices.map(inv => ({
      ...inv,
      vendorCode: event.target.value
    })));
  };

  const handleInvoiceClick = (index) => {
    const updatedInvoices = [...invoices];
    updatedInvoices[index].selected = !updatedInvoices[index].selected;
    setInvoices(updatedInvoices);
  };

  return (
    <AppLayout userName={userName}>
      <Tabbar />
      <div className={classes.content}>
        <form onSubmit={handleBulkScan}>
          <input type="file" name="files" multiple onChange={handleFileChange} />
          <input type="text" value={bulkVendorCode} onChange={handleVendorCodeChange} placeholder="Bulk Vendor Code" />
          <button type="submit">Scan Invoices</button>
        </form>

        <div className={classes.gridContainer}>
          {invoices.map((invoice, index) => (
            <div key={index} className={`${classes.gridItem} ${invoice.selected ? classes.selected : ''}`} onClick={() => handleInvoiceClick(index)}>
              <img src={`data:image/jpeg;base64,${invoice.imageFile}`} alt={`Invoice ${index + 1}`} />
              <div className={classes.overlay}>
                <input type="text" value={invoice.vendorCode} onChange={(e) => handleVendorCodeChange(e, index)} placeholder="Enter Vendor Code" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </AppLayout>
  );
};

export default BulkScan;
